import { render, staticRenderFns } from "./AllChannelList.vue?vue&type=template&id=b42e18b2"
import script from "./AllChannelList.vue?vue&type=script&lang=js"
export * from "./AllChannelList.vue?vue&type=script&lang=js"
import style0 from "./AllChannelList.vue?vue&type=style&index=0&id=b42e18b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports